import React, { useCallback, useEffect, useState } from "react";

import { addFundingOpportunity, getMethods } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate } from "utils";

import { AdminHead, AdminSection, Button, Col, ErrorBoundary, Form, MainPage, Row, TextArea, TextEditor, Message as message } from "components";

import { FundingInputs } from "pages/admin/programs/components/FundingInputs";

export const FundingAdd = () => {
  const [fundingOpportunity, setFundingOpportunity] = useState({});
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadMethods = useCallback(() => {
    getMethods({
      signal,
    })
      .then((res) => {
        setMethods(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const handleExplainerChange = (v) => {
    setFundingOpportunity({
      ...fundingOpportunity,
      fundingAmountExplainer: v,
    });
  };

  const complete = (v) => {
    setLoading(true);

    addFundingOpportunity({
      ...v,
      active: true,
      conditions: v.conditions.split("\n"),
      fundingAmountExplainer: fundingOpportunity.fundingAmountExplainer,
      signal,
    })
      .then(() => {
        navigate("/programs/funding");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadMethods();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Add EU funding"
        link="/programs/funding"
        tooltipText="Back to funding"
        description="Add a new funding opportunity here. Funding opportunities can apply to multiple methods and regions."
      />
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <ErrorBoundary>
              <FundingInputs methods={methods} />
            </ErrorBoundary>

            <AdminSection headline="Funding conditions" />
            <Row>
              <Col>
                <TextArea initialValue="" name="conditions" label="One per line" rules={[{ required: true }]} autoSize={{ minRows: 4 }} />
              </Col>
            </Row>

            <AdminSection headline="Funding explanation" />
            <Row>
              <Col>
                <TextEditor initialValue="" onEditorChange={(v) => handleExplainerChange(v)} value={fundingOpportunity.fundingAmountExplainer} />
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
